export const textScale: any = [0.5, 0.5, 0.5];
export const textColor = '#000000';
export const textFontUrl = 'https://fonts.gstatic.com/s/raleway/v14/1Ptrg8zYS_SKggPNwK4vaqI.woff';
